/*
Door Closers

  --closer <boolean::switch> | ['Top', 'Bottom']
*/

import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Closer',
    value: 'closer',
    type: 'list',
    returnObject: false
  }
]
